import { useRef, useState } from 'react'

const SHIPPING_TAB_LITERAL = 'Shipping'
const BILLING_TAB_LITERAL = 'Billing'

const MODAL_TABS = [SHIPPING_TAB_LITERAL, BILLING_TAB_LITERAL] as const
export type ModalTab = (typeof MODAL_TABS)[number]

const SHIPPING_TAB_INDEX = MODAL_TABS.indexOf(SHIPPING_TAB_LITERAL)
const BILLING_TAB_INDEX = MODAL_TABS.indexOf(BILLING_TAB_LITERAL)

export function useShippingBillingTabs(initialTab?: ModalTab) {
  const tab: ModalTab = initialTab ?? SHIPPING_TAB_LITERAL

  const initialActiveTabIndex = MODAL_TABS.indexOf(tab)
  const activeTabRef = useRef<ModalTab>(tab)

  const [tabIndex, setTabIndex] = useState<number>(initialActiveTabIndex)

  const toggleTab = () => {
    const index =
      tabIndex === SHIPPING_TAB_INDEX ? BILLING_TAB_INDEX : SHIPPING_TAB_INDEX
    setTabIndex(index)
    activeTabRef.current = MODAL_TABS[index]
  }

  return {
    tabIndex,
    toggleTab,
    activeTab: activeTabRef.current,
  }
}
